<template>
  <CardPrimary :style="cardStyle">
    <div :style="leftContainerStyle">
      <div :style="upperContainerStyle">
        <HybridLinkUserImagePrimary v-bind="userImageAttrs"
                                    :openInCurrentTab="false"
                                    :src="tenantUser.user.image"
                                    :tenantUserId="tenantUser.id" />
        <div :style="userProfileContainerStyle">
          <HybridLinkNameLargePrimary :isRouterLink="false"
                                      :openInCurrentTab="false"
                                      :style="userNameStyle"
                                      :tenantUserId="tenantUser.id"
                                      :truncate="true">
            {{ tenantUser.user.firstName }} {{ tenantUser.user.lastName }}
          </HybridLinkNameLargePrimary>
          <IconTextPrimary content="person_pin"
                           :style="iconTextStyle"
                           :truncate="true">
            {{ title }}
          </IconTextPrimary>
          <IconTextPrimary content="location_on"
                           :style="iconTextStyle"
                           :truncate="true">
            {{ location }}
          </IconTextPrimary>
        </div>
      </div>
      <div :style="lowerContainerStyle">
        <slot name="left-lower-container" />
      </div>
    </div>
    <div :style="rightContainerStyle">
      <SkillGraphSecondary v-bind="skillGraphAttrs"
                           :isHighlighted="isHighlighted"
                           :labelMaxLength="labelMaxLength"
                           :links="skillEdges"
                           :nodes="skillNodes" />
    </div>
  </CardPrimary>
</template>

<script>
  import CardPrimary from '@modules/card/card-primary'
  import HybridLinkNameLargePrimary from '@modules/link/hybrid-link-name-large-primary'
  import HybridLinkUserImagePrimary from '@modules/link/hybrid-link-user-image-primary'
  import IconTextPrimary from '@modules/text/icon-text-primary'
  import SkillGraphSecondary from '@modules/graph/skill-graph-secondary'
  import { Layout } from '@js/styles'
  import { getTenantUserSkillEdges } from '@js/skill-utils'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SearchedUserPrimary',
    components: {
      CardPrimary,
      IconTextPrimary,
      HybridLinkNameLargePrimary,
      HybridLinkUserImagePrimary,
      SkillGraphSecondary,
    },
    props: {
      isHighlighted: { type: Function, required: false, default: (node) => { return node.srcText !== ''; } },
      tenantUser: { type: Object, required: false, default: () => {} },
      tenantUserSkills: { type: Array, required: false, default: () => [] },
    },
    data: function () {
      return {
        cardStyle: {
          display: 'flex',
          height: '200px',
          justifyContent: 'space-between',
          width: '100%',
        },
        iconTextStyle: {
          margin: `${Layout.space.xs} 0 0 0`,
        },
        labelMaxLength: -1,
        leftContainerStyle: {
          alignSelf: 'stretch',
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'space-beteen',
          padding: `${Layout.space.md} 0 ${Layout.space.md} ${Layout.space.md}`,
          maxWidth: 'calc(100% - 400px)',
        },
        lowerContainerStyle: {
          width: '100%',
        },
        rightContainerStyle: {
          alignSelf: 'stretch',
          border: 'solid transparent',
          borderRadius: '0 8px 8px 0',
          borderWidth: '0px',
          minWidth: '400px',
          width: '400px',
        },
        skillGraphAttrs: {
          cursorOnHover: 'pointer',
          height: 200,
          maxWidth: 400,
          neighborsKeyName: 'targets',
          width: 400,
        },
        upperContainerStyle: {
          display: 'flex',
          flex: 1,
          width: '100%',
        },
        userImageAttrs: {
          height: '80px',
          width: '80px',
        },
        userNameStyle: {
          margin: '-8px 0',
        },
        userProfileContainerStyle: {
          height: '100%',
          padding: `0 0 0 ${Layout.space.md}`,
          width: 'calc(100% - 80px)',
        },
      };
    },
    created: function () {
      this.rightContainerStyle = {
        ...this.rightContainerStyle,
        backgroundColor: this.color.shadow1(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      location: function () {
        const location = this.tenantUser.location;
        return (location != null && location.length > 0) ? location : 'N/A';
      },
      skillNodes: function () {
        return this.tenantUserSkills;
      },
      skillEdges: function () {
        return getTenantUserSkillEdges(this.tenantUserSkills);
      },
      title: function () {
        const title = this.tenantUser.title;
        return (title != null && title.length > 0) ? title : 'N/A';
      },
    },
  };
</script>
